const testimonials = [
  { name: '田中 美咲様', role: '和食店オーナー', avatar: 'bg-rose-200', text: '「花木流味噌 五反野店」での食事は毎回特別な体験です。コンサルティングも受けましたが、的確なアドバイスで売上が大きく改善しました。' },
  { name: '佐藤 健太様', role: 'イタリアンレストラン経営', avatar: 'bg-cyan-200', text: '開業時から全面的にサポートしていただきました。実践的なアドバイスのおかげで、初年度から黒字化を達成できました。' },
  { name: '鈴木 由美様', role: 'カフェオーナー', avatar: 'bg-amber-200', text: '経営に行き詰まっていた時、栄伸さんに相談して本当に良かったです。半年で売上が150%に伸びました。' },
  { name: '山田 誠様', role: '居酒屋チェーン代表', avatar: 'bg-emerald-200', text: 'スタッフ教育プログラムを導入してから、サービス品質が向上し、お客様満足度も大幅にアップしました。' },
  { name: '高橋 麻衣様', role: 'ビストロオーナー', avatar: 'bg-purple-200', text: 'メニュー構成の見直しで原価率を5%改善できました。具体的で実践しやすいアドバイスが魅力です。' },
  { name: '伊藤 大輔様', role: 'ラーメン店経営', avatar: 'bg-teal-200', text: '実践経験に基づいたアドバイスが本当に役立ちます。現場で使えるノウハウをすぐに実行できるのが魅力です。' },
];

export default function TestimonialsSection() {
  return (
    <section className="py-14 md:py-24 bg-gradient-to-br from-gray-50 to-slate-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10 md:mb-16">
          <div className="inline-block bg-white text-gray-600 px-3 py-1 rounded-full text-xs font-medium mb-4 md:mb-6">
            CLIENT VOICE
          </div>
          <h2 className="text-2xl md:text-5xl font-bold text-slate-800 leading-tight">
            お客様から
          </h2>
          <h2 className="text-2xl md:text-5xl font-bold text-slate-800 leading-tight">
            いただいた声
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8">
          {testimonials.map((t, index) => (
            <div key={index} className="bg-white rounded-xl md:rounded-2xl p-5 md:p-8 hover:shadow-lg transition-all duration-300">
              <div className="flex items-center gap-3 md:gap-4 mb-4 md:mb-6">
                <div className={`w-10 h-10 md:w-14 md:h-14 flex items-center justify-center ${t.avatar} rounded-full flex-shrink-0`}>
                  <i className="ri-user-line text-lg md:text-2xl text-slate-700"></i>
                </div>
                <div>
                  <div className="text-sm md:text-base font-bold text-slate-800">{t.name}</div>
                  <div className="text-xs text-gray-500">@{t.role}</div>
                </div>
              </div>
              <p className="text-xs md:text-base text-gray-700 leading-relaxed">
                「{t.text}」
              </p>
              <div className="mt-4 md:mt-6 flex gap-1">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-amber-400 text-sm"></i>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
